// removed by extract-text-webpack-plugin
module.exports = {"PreviewWrapper":"_1BVEt-y4WHFit9T7A7RBjz","PreviewHeader":"_1_BWWPsVclX_Z6UmRIWdMy","TicketNumber":"LPdafn-wFT4rPwWNpJtGm","FirstEntry":"_223AAJ51XVO3iqFr5zlKEx","BodyInfo":"_1SdfRGpATnpyrYplauBVEa"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Ticket/Preview/style.css
// module id = 1547
// module chunks = 0